module.exports = __webpack_public_path__ + "img/12.123920e8.png";